import { Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import headerImg from "../assets/img/header-img.svg";
export const Banner = () => {
  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items=center">
          <Col xs={12} md={6} xl={7}>
            <span className="tagline">Welcome</span>
            <h1>{"Hello, I am Aditya Surve"}</h1>
            <h2>
              I am a{" "}
              <table border="0" className="wrap">
                <tr>
                  <td>Web Developer</td>
                </tr>
                <tr>
                  <td>Native App Developer</td>
                </tr>
                <tr>
                  <td>AI/ML Enthusiast</td>
                </tr>
              </table>
            </h2>
            <p>This is my portfolio website.</p>
            <button onClick={() => console.log("connect")}>
              Let's Connect <ArrowRightCircle size={25} />
            </button>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <img src={headerImg} alt="Header Img" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};
